module.exports = "<footer class=\"app-footer\">\n    <span>&copy; {{currentYear}} Blockoville. All rights reserved.</span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/_layout/footer/footer.component.html
// module id = ./src/app/_layout/footer/footer.component.html
// module chunks = main